import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {BeneficiariesRoutingModule} from './beneficiaries-routing.module';
import {BeneficiariesCreateComponent} from './beneficiaries-create/beneficiaries-create.component';
import {BeneficiariesListComponent} from './beneficiaries-list/beneficiaries-list.component';
import {MaterialModule} from '../../material.module';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../utils/shared.module';
import {SharedComponentsModule} from '../../shared-components/shared-components.module';


@NgModule({
    declarations: [
        BeneficiariesCreateComponent,
        BeneficiariesListComponent
    ],
    imports: [
        CommonModule,
        BeneficiariesRoutingModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        SharedComponentsModule,
    ]
})
export class BeneficiariesModule {
}
